module.exports = {
      id: "video-play-usage",
      viewBox: "0 0 58.316 58.344",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#video-play",
      toString: function () {
        return this.url;
      }
    }